/**
 * Function to format a price.
 *
 * @param {String|Number} price
 * @param {Number} fractionDigits
 *
 * @return {String}
 */
export const price = (price: number, fractionDigits = 2): string => {
  const fixed = (Math.round(price * 100) / 100).toFixed(fractionDigits);

  const formatted = fixed.replace(/\./g, ',');

  return formatted + '€';
};
